export class InvoiceAcctRequestDTO {
    id: number;
    details:boolean;

    constructor(data?: any) {
        this.id = data?.id ?? 0;
        this.details = data?.details ?? false;
    }
}